import { createOperation } from "src/features/operations";

export const saveSecuredPaymentMethodOperation = createOperation<void>("OPEN_TABLE/SAVE_SECURED_PAYMENT_METHOD", {
    showSpinner: true,
});
